import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'
import { Grid as BaseGrid, styled } from '@mui/material'
import React from 'react'
import { Link as BaseLink } from 'react-router-dom'

export const BaseContainer = styled(props => <BaseGrid container {...props} />)`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const BaseItem = styled(props => <BaseGrid item {...props} />)`
  gap: ${props => props.gap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const Container = styled(BaseContainer)``

export const Item = styled(BaseItem)``

export const Strong = styled('span')`
  font-weight: bold;
`

export const NotFoundImg = styled('img')`
  height: auto;
  width: 48px;
`

export const Link = styled(BaseLink)`
  color: ${props => props.theme.palette.blue[50]};
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    text-decoration: underline;
  }
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
    vertical-align: middle;
  }
`

export const TableContainer = styled('div')`
  overflow-x: auto;
  width: 100%;
`
